import fetch from '@/util/http'

export default {
  getJSSdkCofnig(data) {
    return fetch.get(`member/jsapi_ticket`, data)
  },
  login(model) {
    return fetch.post('member/login/mobile', model)
  },
  userInfo() {
    return fetch.get('member/info')
  },
  getWxConfig() {
    return fetch.get('app_wechat_config')
  },
  getShareConfig () {
    return fetch.get('wechat_share_config/get', { code: 'activity' })
  },
  getFollowConfig() {
    return fetch.get('member/subscribe_status')
  },
  pay(model) {
    return fetch.post('pay', model)
  }
}



// WEBPACK FOOTER //
// ./src/api/core.js